import { DisconnectOutlined } from "@ant-design/icons";
import { observer } from "mobx-react";
import { useCallback } from "react";
import { RealCommerceError } from "../../../../../exceptions";
import { useRealCommerceErrorHandling } from "../../../../../hooks";
import { providedModal } from "../../../../../others";
import { IMPREZA_BUTTON_PROPS, __, _i } from "../../../../../utils";
import { App } from "antd";
const AccountLicenseActivationActions = observer(_ref => {
  let {
    record
  } = _ref;
  const {
    modal: antdModal
  } = App.useApp();
  const handleRealCommerceError = useRealCommerceErrorHandling();
  const handleDeleteClick = useCallback(async () => {
    const modal = providedModal("confirm", _i(__("By revoking the license activation, {{strong}}%s{{/strong}} will no longer be fully usable on {{code}}%s{{/code}} (e.g. no more updates) until a license is activated again. Do you really want to do that?", record.store.data.product.name, record.host), {
      strong: /*#__PURE__*/React.createElement("strong", null),
      code: /*#__PURE__*/React.createElement("code", null)
    }), antdModal, {
      title: __("Are you sure to revoke (disconnect) this license activation?"),
      icon: /*#__PURE__*/React.createElement(DisconnectOutlined, null),
      okButtonProps: {
        ...IMPREZA_BUTTON_PROPS,
        onClick: async e => {
          e.preventDefault();
          modal.update({
            okButtonProps: {
              ...IMPREZA_BUTTON_PROPS,
              loading: true
            }
          });
          try {
            await record.delete();
            modal.destroy();
          } catch (e) {
            if (e instanceof RealCommerceError) {
              handleRealCommerceError(e);
            }
          }
        }
      },
      okText: __("Disconnect now")
    });
  }, [record]);
  return /*#__PURE__*/React.createElement("a", {
    style: {
      color: "#ff4d4f"
    },
    onClick: handleDeleteClick
  }, __("Revoke (Disconnect)"));
});
export { AccountLicenseActivationActions };